var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg13B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1 0 0 1 0 -987.362121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3336"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.66,
    fill: "none",
    stroke: "#000000",
    d: "M0.94 1019.97 C0.94 1002.59 15.14 988.46 32.62 988.46 C50.11 988.46 64.31 1002.59 64.31 1019.97 C64.31 1037.36 50.11 1051.48 32.62 1051.48 C15.14 1051.48 0.94 1037.36 0.94 1019.97 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3338"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.17,
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M15.62 1019.07 C15.62 1010.3 23.09 1003.18 32.27 1003.18 C41.46 1003.18 48.92 1010.3 48.92 1019.07 C48.92 1027.83 41.46 1034.95 32.27 1034.95 C23.09 1034.95 15.62 1027.83 15.62 1019.07 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tspan3344",
    transform: "matrix(1.011259 0 0 0.988867 15.754672 1006.090026)"
  }, /*#__PURE__*/React.createElement("text", {
    kerning: 0,
    fontFamily: ".AppleSystemUIFont",
    fontWeight: 700,
    fontSize: 22.14
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.41
  }, "13"))), /*#__PURE__*/React.createElement("g", {
    id: "a4153",
    transform: "matrix(0.658448 0 0 0.657214 -0.608593 987.247924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3349"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.01,
    fill: "#0000ff",
    stroke: "#000000",
    d: "M15.88 16.46 L85.3 16.46"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path3351"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.66,
    fill: "none",
    stroke: "#000000",
    d: "M8.17 1039.95 L57.23 1039.69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path4158"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff6600",
    d: "M7.18 1038.51 C4.18 1034.43 2.16 1029.54 1.38 1024.44 C1.06 1022.29 1.05 1017.57 1.38 1015.52 C2.37 1009.26 4.88 1003.88 8.96 999.24 L9.7 998.41 L32.7 998.47 L55.7 998.53 L56.74 999.76 C59.5 1003.01 61.77 1007.23 62.97 1011.39 C64.84 1017.82 64.48 1025.18 62.01 1031.42 C61.11 1033.68 59.39 1036.76 58.05 1038.51 L57.43 1039.31 L39.87 1039.38 C30.22 1039.42 19.09 1039.48 15.15 1039.52 L7.98 1039.6 L7.18 1038.51 Z M34.9 1034.88 C36.75 1034.6 38.29 1034.11 40 1033.26 C41.82 1032.36 42.97 1031.54 44.4 1030.11 C47.43 1027.1 49.01 1023.32 49.02 1019.09 C49.02 1014.94 47.57 1011.31 44.69 1008.31 C41.07 1004.56 36.14 1002.71 30.84 1003.13 C29.29 1003.25 27.2 1003.72 25.87 1004.24 C21.37 1006.01 17.74 1009.8 16.26 1014.25 C15.24 1017.31 15.29 1021.2 16.39 1024.27 C17.95 1028.59 21.45 1032.14 25.89 1033.89 C26.94 1034.31 28.64 1034.76 29.81 1034.93 C31.04 1035.1 33.57 1035.08 34.9 1034.88 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3418",
    transform: "matrix(1 0 0 1 0 987.362121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M30 63.54 C22.67 62.93 15.58 59.65 10.61 54.55 L9.12 53.03 L32.62 52.89 C45.55 52.81 56.18 52.79 56.23 52.85 C56.29 52.91 55.47 53.79 54.41 54.82 C47.89 61.1 39 64.28 30 63.54 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3420",
    transform: "matrix(1 0 0 1 0 987.362121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M11.62 9.62 C13.6 7.54 19.35 4.22 22.97 3.05 C26.28 1.99 28.18 1.72 32.59 1.72 C37.12 1.72 38.92 1.98 42.49 3.15 C46.22 4.36 50.51 6.81 53.01 9.14 L54.26 10.3 L32.6 10.31 L10.94 10.32 L11.62 9.62 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13B);
export default __webpack_public_path__ + "static/media/13B.79a0cecf536e77a4d6f824f9fcf2f434.svg";
export { ForwardRef as ReactComponent };